// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__wDH-f","footer":"ChangeClinic_footer__1Astp"};